<template>
  <div v-if="!!phaseData">
    <div>
      <field-label label="Resultado dos testes" titleClass="text-h6" titleColorClass="grey--text text--darken-2">
        <div class="mt-4 d-flex flex-row gap-12">
          <field-label label="DLQI">
            <div class="d-flex gap-2 mt-2 align-center">
              <text-field
                :min="0"
                type="number"
                v-if="phaseData.resultado_manual"
                v-model="phaseData.dlqi.value"
                :max="30"
              />
              <span
                v-else
                :class="{
                  'red--text': phaseData.dlqi.value > 9,
                  'black--text text-h6': phaseData.dlqi.value == null,
                  'big-number': phaseData.dlqi.value != null,
                }"
                >{{ phaseData.dlqi.value == null ? 'Indefinido' : phaseData.dlqi.value }}</span
              >
              <span
                v-if="phaseData.dlqi.value"
                class="ml-2"
                :class="{ 'red--text': phaseData.dlqi.value > 9 }"
                style="width: 120px"
                >{{ phaseData.dlqi.value > 9 ? 'Moderado a grave' : 'Leve' }}</span
              >
            </div>
          </field-label>
        </div>

        <v-switch
          class="my-4"
          label="Aplicar resultado manualmente"
          v-model="phaseData.resultado_manual"
          hide-details
        />

        <div class="mt-12" v-if="!phaseData.resultado_manual && phaseData.profile">
          <radio-options
            class="mb-2"
            v-for="dlqiOption in dlqiOptions"
            :key="dlqiOption.key"
            v-show="
              dlqiOption.key !== 'impedimento_trabalho_estudo_passado' ||
              phaseData.profile['impedimento_trabalho_estudo_atual'].value === 0
            "
            :label="dlqiOption.name"
            v-model="phaseData.profile[dlqiOption.key].value"
            row
            clearable
            :options="dlqiOption.options || defaultDlqiOptions"
            @input="checkDlqi(dlqiOption.key, $event)"
            :rules="
              pharmaceuticalDomainConfig.SUMMARIZEDFLOW &&
              phaseData.profile['impedimento_trabalho_estudo_atual'].value === 0
                ? [$validation.radioRequired()]
                : []
            "
            :required="dlqiOption.required"
          />
        </div>

        <field-label class="mt-8" label="Anotações">
          <text-area :readonly="disabled" :max-length="2000" v-model="phaseData.notes" />
        </field-label>
      </field-label>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import FieldLabel from '@/components/FieldLabel.vue'
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import TextArea from '@/components/TextArea.vue'
import RadioOptions from '@/components/RadioOptions.vue'
import TextField from '@/components/TextField.vue'
import { DLQI_OPTIONS } from '@/components/AttendanceForm/general/constants/dlqiOptions'

const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')
const { mapGetters: authGettersMap } = createNamespacedHelpers('auth')

export default {
  extends: BasePhase,
  components: { FieldLabel, TextArea, RadioOptions, TextField },
  computed: {
    ...attendanceGettersMap(['getPhaseDataByKey', 'attendancePatient', 'attendance']),
    ...authGettersMap(['pharmaceuticalDomainConfig']),
    defaultDlqiOptions() {
      return [
        { text: 'Realmente muito', value: 3 },
        { text: 'Bastante', value: 2 },
        { text: 'Um pouco', value: 1 },
        { text: 'Nada', value: 0 },
      ]
    },
    computedDlqi() {
      if (!this.phaseData?.profile || this.phaseData?.resultado_manual) {
        return this.phaseData?.dlqi?.value || 0
      }

      let result = 0
      for (let option of this.dlqiOptions) {
        let value = this.phaseData.profile[option.key]?.value || 0

        if (!parseInt(value)) {
          continue
        }

        result += value
      }
      return result
    },
    dlqiOptions() {
      const patientAge = this.$util.toAgeNumber(this.attendancePatient.birthday)
      if (patientAge < 4) {
        return DLQI_OPTIONS.CHILD
      }
      if (patientAge < 18) {
        return DLQI_OPTIONS.MINOR
      }
      return DLQI_OPTIONS.ADULT
    },
  },
  methods: {
    checkDlqi(key, value) {
      if (key === 'impedimento_trabalho_estudo_atual' && this.phaseData.profile[key].value !== 0) {
        this.phaseData.profile['impedimento_trabalho_estudo_passado'] = { value: null }
      }
    },
    postPhaseDataLoaded() {
      if (!this.phaseData.profile) {
        this.$set(this.phaseData, 'profile', this.buildEmptyProfile())
      }
      if (this.phaseData.profile['impedimento_trabalho_estudo_atual'].value === 'NAO') {
        this.phaseData.profile['impedimento_trabalho_estudo_atual'].value = 0
      }
    },
    getDefaultData() {
      const data = {
        dlqi: { value: null },
        resultado_manual: false,
        profile: this.buildEmptyProfile(),
      }
      return data
    },
    buildEmptyProfile() {
      return this.dlqiOptions.reduce((acc, option) => ({ ...acc, [option.key]: { value: null } }), {})
    },
  },
  watch: {
    computedDlqi(newVal) {
      if (this.phaseData.resultado_manual) {
        return
      }
      this.phaseData.dlqi.value = Number(newVal)
    },
  },
}
</script>

<style scoped>
.big-number {
  font-weight: medium;
  color: green;
  font-size: 2.5rem;
}
.area-box {
  border: 1px solid grey;
  border-radius: 10px;
}
.slider-image {
  border: 4px solid #1976d2;
}
</style>
